import Button from 'components/base/Button';
import { Col, Form, Row, Toast, ToastContainer } from 'react-bootstrap';

import { useAuth } from 'providers/AuthProvider'
import { useState, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useNavigate } from 'react-router-dom';
import BlogForm from './components/BlogForm';
import ImageUpload from 'components/common/ImageUpload';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';

const AddBlog = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Blogs'),
            url: '/admin/blogs'
        },
        {
            label: t('Add Blog'),
            active: true
        }
    ];

    const navigate = useNavigate();
    const auth = useAuth();

    // State to store the form data from all child components
    const [formData, setFormData] = useState<any>({ 'blogForm': '', 'notes': '', 'image': null });
    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const onChangeBlogImage = (image: File | null) => {
        if (image) {
            setFormData({ ...formData, ['image']: image });
        }
    };

    // Function to handle form data update from child components
    const updateFormData = (name: string, data: any) => {
        setFormData({ ...formData, [name]: data });
    };



    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        //console.log(formData);
        const form = new FormData();
        form.append('blogForm', JSON.stringify(formData['blogForm']));
        //form.append('notes', formData['notes']);
        form.append('file', formData['image']);

        try {
            const response = await apiClient.post(
                '/v1/blogs/new', form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />
            <div className="mb-9">
                <div>
                    <ToastContainer className="p-3" position='top-center'>
                        <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                            <Toast.Body className=''>{toastMessage}</Toast.Body>
                        </Toast>
                    </ToastContainer>
                </div>
                <Form onSubmit={handleSumbit}>
                    <div className="border-bottom mb-7 mx-n3 px-2 mx-lg-n6 px-lg-6">
                        <Row>
                            <Col xl={12}>
                                <div className="d-sm-flex justify-content-between">
                                    <h2 className="mb-4">Create a new blog</h2>
                                    <div className="d-flex mb-3">
                                        <Button variant="phoenix-primary" className="me-2 px-6" onClick={() => navigate(-1)} >
                                            Back
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col sm={12} md={12} >
                            <BlogForm onUpdate={data => updateFormData('blogForm', data)} className="mb-6" />
                        </Col>
                        <Col sm={12} md={12} >
                            <Row><h4 className="mb-3">Blog Image (best w:350 h:200)</h4></Row>
                            <Row>
                                <ImageUpload src={formData['image'] ? formData['image'] : null} onChange={onChangeBlogImage} className='image-uploader-320h' />
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className="text-end">
                                <Button type="submit" variant="primary" className='mt-2'>Save blog</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
};

export default AddBlog;
